import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../services/siteSettingsService';

const CTASection = () => {
  const { settings } = useSiteSettings();
  const primaryCtaIsExternal = /^(https?:\/\/|mailto:|tel:)/i.test(settings.primaryCtaPath);

  return (
    <section className="py-20 bg-gray-900 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl font-bold text-white mb-4">
            Ne perdez pas une minute de plus !
          </h2>
          <h3 className="text-2xl text-gray-300 mb-8">
            Vous êtes à 1 clic de faire décoller votre trafic
          </h3>
          <div className="max-w-3xl mx-auto space-y-6 text-gray-300">
            <p>
              Dominez le monde numérique et attirez des clients avec {settings.brandFullName} !
              Notre équipe d'experts en conception web, marketing et e-commerce est prête à
              propulser votre entreprise vers de nouveaux sommets en ligne.
            </p>
            <p>
              Grâce à nos solutions personnalisées, nous maximiserons votre visibilité, augmenterons votre trafic et vous aiderons à obtenir un retour sur investissement optimal.
            </p>
            <p>
              Que vous ayez besoin d'un site web percutant, de stratégies marketing efficaces ou de solutions e-commerce performantes, notre équipe saura répondre à vos besoins spécifiques.
            </p>
          </div>
          <div className="mt-12 flex flex-wrap justify-center gap-4">
            {primaryCtaIsExternal ? (
              <a href={settings.primaryCtaPath} className="cta-button glow">
                {settings.primaryCtaLabel}
              </a>
            ) : (
              <Link to={settings.primaryCtaPath} className="cta-button glow">
                {settings.primaryCtaLabel}
              </Link>
            )}
            <button className="flex items-center gap-2 text-white hover:text-neon-orange transition-colors">
              <span className="text-neon-orange">▶</span>
              Voir la vidéo
            </button>
          </div>
        </motion.div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-neon-orange/20 to-transparent"></div>
    </section>
  );
};

export default CTASection;
